export enum PinType {
	PLAIN = 'd_map_pin',
}
